import 'css-chunksrc/client/scenes/costProfileCreation/form/styles.scss';export default {
  "form": "_form_w0fry_1",
  "group": "_group_w0fry_5",
  "row": "_row_w0fry_9",
  "label": "_label_w0fry_19",
  "description": "_description_w0fry_24"
};